import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section className="bg-brand-cream px-4 py-20 sm:py-24" data-id="element-29" data-mp="vswba7h3yvg8">
      <Reveal className="mx-auto max-w-3xl" data-id="element-30" data-mp="vuh6lzb8yif5">
        <SectionHeading eyebrow="Incluidos sin costo" title={<>
              <span aria-hidden="true" data-id="element-32" data-mp="14tb0hhx70up0">🎁</span> 5 Bonos Exclusivos
            </>} subtitle="Incluidos GRATIS con tu compra" data-id="element-31" data-mp="qu2xsf1tn4g2" />
        <div className="mt-14 space-y-4" data-id="element-33" data-mp="ztybaqiunbj9">
          {bonuses.map(bonus => <article key={bonus.title} className="flex items-center gap-5 rounded-2xl border border-brand-line bg-brand-alt p-4 shadow-[0_6px_20px_rgba(23,32,60,0.04)] sm:gap-6 sm:p-5" data-id="element-34" data-mp="1ei2mzajhimsj">
              <img src={bonus.cover} alt={`Tapa del Bono ${bonus.number}: ${bonus.title}`} className="h-28 w-[5.25rem] shrink-0 rounded-lg border border-brand-line object-cover shadow-sm sm:h-32 sm:w-[6.25rem]" loading="lazy" data-id="element-35" data-mp="1nhzh3ron8duz" />
              <div className="min-w-0 flex-1" data-id="element-36" data-mp="3tu00bt98pqlu">
                <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-brand-gold" data-id="element-37" data-mp="2lcmdydbx5ob">
                  Bono {bonus.number}
                </p>
                <h3 className="mt-1.5 text-base font-semibold leading-snug text-brand-navy sm:text-lg" data-id="element-38" data-mp="7iclfpbrh85x">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-xs leading-relaxed text-brand-gray sm:text-sm" data-id="element-39" data-mp="gk2knhbvxbe9">
                  {bonus.description}
                </p>
              </div>
              <div className="shrink-0 text-right" data-id="element-40" data-mp="qbq7f4xhy49e">
                <p className="text-xs text-brand-gray line-through" data-id="element-41" data-mp="qaf1ozkhqmfn">
                  {bonus.value}
                </p>
                <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-brand-terra" data-id="element-42" data-mp="v8gonvl1f5we">
                  Gratis
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}